"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = void 0;
var React = require("react");
var react_select_1 = require("react-select");
var Theme_1 = require("../../Theme");
exports.SelectInput = React.forwardRef(function (_a, ref) {
    var LabelledBy = _a.LabelledBy, OnChange = _a.OnChange, HasErrors = _a.HasErrors, Name = _a.Name, Value = _a.Value, Placeholder = _a.Placeholder, Options = _a.Options, Disabled = _a.Disabled;
    return (React.createElement(react_select_1.default, { "aria-labelledby": LabelledBy, name: Name, value: Value, onChange: OnChange, isDisabled: Disabled, options: Options, placeholder: Placeholder, theme: function (theme) { return (__assign(__assign({}, theme), { borderRadius: 5, colors: __assign(__assign({}, theme.colors), { neutral20: HasErrors ? Theme_1.Color.Red.R60 : Theme_1.Color.Grey.G30, neutral50: Theme_1.Color.Grey.G80 }), spacing: __assign(__assign({}, theme.spacing), { controlHeight: 40 }) })); }, closeMenuOnSelect: true, inputId: Name, ref: ref }));
});
